module.exports = __webpack_public_path__ + "static/13.4_the_rise_of_rome-a47968836b387791da09147c4d95ac56.pdf";